import {
  FileUploadButton,
  InputDescriptionWrap,
  MultipleFileUpload,
} from 'components'
import { FieldArray, useFormikContext } from 'formik'
import { IVenueFormValues } from './FormPage'
import { inputDescriptions } from './inputDescriptions'

export const ImagesStep = () => {
  const { values, setFieldValue } = useFormikContext<IVenueFormValues>()

  return (
    <>
      <InputDescriptionWrap text={inputDescriptions.images.thumbnail}>
        <FileUploadButton
          name="thumbnail"
          fileObj={values.thumbnail as File}
          onSubmit={(file) => setFieldValue('thumbnail', file)}
        />
      </InputDescriptionWrap>

      <InputDescriptionWrap text={inputDescriptions.images.photos}>
        <FieldArray name="photos">
          {({ remove, push }) => (
            <MultipleFileUpload
              name="photos"
              onRemoveFile={remove}
              onDrop={(acceptedFiles) =>
                acceptedFiles.forEach((file) => push({ file: file }))
              }
            />
          )}
        </FieldArray>
      </InputDescriptionWrap>
    </>
  )
}
